"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiRefundResponseDto = void 0;
const billing_core_refund_cancel_reason_enum_1 = require("../../../../billing-core/billing-core-refund/types/enums/billing-core-refund-cancel-reason.enum");
const billing_core_refund_reason_enum_1 = require("../../../../billing-core/billing-core-refund/types/enums/billing-core-refund-reason.enum");
const swagger_1 = require("../../../../swagger-fake");
const class_validator_1 = require("class-validator");
class BillingApiRefundResponseDto {}
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id возврата",
  format: "uuid"
}), (0, class_validator_1.IsUUID)(4), __metadata("design:type", String)], BillingApiRefundResponseDto.prototype, "id", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id возвращаемого платежа.",
  format: "uuid",
  type: String
}), (0, class_validator_1.IsUUID)(4), __metadata("design:type", String)], BillingApiRefundResponseDto.prototype, "paymenId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Сумма возврата (меньше либо равно сумме платежа)`,
  type: String,
  format: "decimal",
  pattern: "^d{1,}(.d{1,6})?$",
  example: "100.00"
}), (0, class_validator_1.IsDecimal)({
  decimal_digits: "1,"
}), __metadata("design:type", String)], BillingApiRefundResponseDto.prototype, "amount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Причина возврата.`,
  enum: billing_core_refund_reason_enum_1.BillingCoreRefundReasonEnum
}), (0, class_validator_1.IsEnum)(billing_core_refund_reason_enum_1.BillingCoreRefundReasonEnum), __metadata("design:type", String)], BillingApiRefundResponseDto.prototype, "reason", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Комментарий к возврату.`,
  enum: billing_core_refund_cancel_reason_enum_1.BillingCoreRefundCanceleReasonEnum
}), (0, class_validator_1.IsString)(), __metadata("design:type", Object)], BillingApiRefundResponseDto.prototype, "comment", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Причина отмены возврата.`,
  enum: billing_core_refund_cancel_reason_enum_1.BillingCoreRefundCanceleReasonEnum,
  nullable: true,
  required: false
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsEnum)(billing_core_refund_cancel_reason_enum_1.BillingCoreRefundCanceleReasonEnum), __metadata("design:type", Object)], BillingApiRefundResponseDto.prototype, "canceledReason", void 0);
exports.BillingApiRefundResponseDto = BillingApiRefundResponseDto;
